import { SelectableItem } from '@app/components/base/content-structure/SelectableItem';
import { ConnectionAvatar } from '@app/modules/social-export/components/ConnectionAvatar';
import { ConnectionDisplayName } from '@app/modules/social-export/components/ConnectionDisplayName';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { connectionsManageMessages as messages } from './connections-manage-messages';

type Props = {
  platform: SocialPlatform;
  connection: SocialExportGetConnectionStateDto;
  selected: boolean;
  onSelect: (connectionId: string) => void;
};

/**
 * Selectable list item for a client-owned social connection.
 */
export function ConnectionListItem({ platform, connection, selected, onSelect }: Props) {
  const { $t } = useIntl();
  const linkedStationsCount = connection.stationIds.length;
  const hasLinkedStations = linkedStationsCount > 0;

  return (
    <SelectableItem selected={selected} onClick={() => onSelect(connection.id)}>
      <ConnectionAvatar
        connection={connection}
        platform={platform}
        sx={{ width: 40, height: 40 }}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <ConnectionDisplayName
          connection={connection}
          platform={platform}
          variant="subtitle2"
          noWrap
          color="text.primary"
        />
        <Typography
          variant="body2"
          color={hasLinkedStations ? 'text.secondary' : 'warning.main'}
          noWrap
        >
          {$t(messages.linkedStationsCount, {
            count: linkedStationsCount,
          })}
        </Typography>
      </Box>
    </SelectableItem>
  );
}
